import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'taskFeedback';

const taskFeedbackService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  getRow: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/row/${encodeURIComponent(id)}`,
    });
  },

  createRow: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      formData: true,
      data,
    });
  },

  updateRow: (data, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      formData: true,
      data,
    });
  },

  deleteRow: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};

export default taskFeedbackService;
